// export interface TreeNode {
//     value: number;
//     left?: TreeNode;
//     right?: TreeNode;
// }

const result16 = { value: 51, left: undefined, right: undefined }; //INFP 러시안 블루
const result15 = { value: 50, left: undefined, right: undefined }; //INTJ 먼치킨
const result14 = { value: 49, left: undefined, right: undefined }; //ISFJ 페르시안
const result13 = { value: 48, left: undefined, right: undefined }; //INFJ 스핑크스
const result12 = { value: 47, left: undefined, right: undefined }; //ISTP 퍼그
const result11 = { value: 46, left: undefined, right: undefined }; //INTP 스코티시 폴드
const result10 = { value: 45, left: undefined, right: undefined }; //ISFP 노르웨이숲
const result09 = { value: 44, left: undefined, right: undefined }; //ISTJ 터키쉬 앙고라
const result08 = { value: 43, left: undefined, right: undefined }; //ENTJ 도베르만
const result07 = { value: 42, left: undefined, right: undefined }; //ENFP 비글
const result06 = { value: 41, left: undefined, right: undefined }; //ESFJ 골든 리트리버
const result05 = { value: 40, left: undefined, right: undefined }; //ENFJ 푸들
const result04 = { value: 39, left: undefined, right: undefined }; //ESTP 보더콜리
const result03 = { value: 38, left: undefined, right: undefined }; //ENTP 슈나우저
const result02 = { value: 37, left: undefined, right: undefined }; //ESFP 닥스훈트
const result01 = { value: 36, left: undefined, right: undefined }; //ESTJ 포메라니안

const choice8_8 = { value: 35, left: result15, right: result16 };
const choice8_7 = { value: 34, left: result13, right: result14 };
const choice8_6 = { value: 33, left: result11, right: result12 };
const choice8_5 = { value: 32, left: result09, right: result10 };
const choice8_4 = { value: 31, left: result07, right: result08 };
const choice8_3 = { value: 30, left: result05, right: result06 };
const choice8_2 = { value: 29, left: result03, right: result04 };
const choice8_1 = { value: 28, left: result01, right: result02 };

const choice7_7 = { value: 27, left: choice8_7, right: choice8_8 };
const choice7_6 = { value: 26, left: choice8_6, right: choice8_7 };
const choice7_5 = { value: 25, left: choice8_5, right: choice8_6 };
const choice7_4 = { value: 24, left: choice8_4, right: choice8_5 };
const choice7_3 = { value: 23, left: choice8_3, right: choice8_4 };
const choice7_2 = { value: 22, left: choice8_2, right: choice8_3 };
const choice7_1 = { value: 21, left: choice8_1, right: choice8_2 };

const choice6_6 = { value: 20, left: choice7_6, right: choice7_7 };
const choice6_5 = { value: 19, left: choice7_5, right: choice7_6 };
const choice6_4 = { value: 18, left: choice7_4, right: choice7_5 };
const choice6_3 = { value: 17, left: choice7_3, right: choice7_4 };
const choice6_2 = { value: 16, left: choice7_2, right: choice7_3 };
const choice6_1 = { value: 15, left: choice7_1, right: choice7_2 };

const choice5_5 = { value: 14, left: choice6_5, right: choice6_6 };
const choice5_4 = { value: 13, left: choice6_4, right: choice6_5 };
const choice5_3 = { value: 12, left: choice6_3, right: choice6_4 };
const choice5_2 = { value: 11, left: choice6_2, right: choice6_3 };
const choice5_1 = { value: 10, left: choice6_1, right: choice6_2 };

const choice4_4 = { value: 9, left: choice5_4, right: choice5_5 };
const choice4_3 = { value: 8, left: choice5_3, right: choice5_4 };
const choice4_2 = { value: 7, left: choice5_2, right: choice5_3 };
const choice4_1 = { value: 6, left: choice5_1, right: choice5_2 };

const choice3_3 = { value: 5, left: choice4_3, right: choice4_4 };
const choice3_2 = { value: 4, left: choice4_2, right: choice4_3 };
const choice3_1 = { value: 3, left: choice4_1, right: choice4_2 };

const choice2_2 = { value: 2, left: choice3_2, right: choice3_3 };
const choice2_1 = { value: 1, left: choice3_1, right: choice3_2 };

export const root = { value: 0, left: choice2_1, right: choice2_2 };